import RootState from "~/types/store";

export const ANALYZE_DATA_KEY = "ANALYZE_DATA";

export const getModuleState = (state: RootState): any => state[ANALYZE_DATA_KEY];

export const getAllowedPrompts = (state: RootState) => getModuleState(state).allowedPrompts;
